import { SnackbarStatus } from '@weareopenr/component-library';

export const errorNotificationChannelVenues = {
  status: SnackbarStatus.ERROR,
  message: 'Something went wrong fetching Channels and Venues',
} as const;

export const noChannelsSelectedNotification = {
  status: SnackbarStatus.ERROR,
  message: 'You must select at least one channel and venue to publish this menu',
} as const;

export const successNotification = (menuName: string, channelNames: string[], scheduleTime: string) =>
  ({
    status: SnackbarStatus.SUCCESS,
    message: `You have successfully ${scheduleTime ? 'scheduled ' : 'published '} ${menuName} to ${channelNames.join(', ')}`,
  }) as const;

export const errorNotification = (menuName: string, scheduleTime: string, error?: string) =>
  ({
    status: SnackbarStatus.ERROR,
    message: error || `Something went wrong whilst ${scheduleTime ? 'scheduling ' : 'publishing '} ${menuName}`,
  }) as const;
